import React, { useEffect, useState, useRef } from 'react';
import dayjs from 'dayjs';
import { Button, Icon } from '@chakra-ui/react';
import { FcGoogle } from 'react-icons/fc';
import { config } from '../../../../config';

/**
 *	Login with Browser component
 * @param {{
 * 	onTimeout: () => void,
 * 	onClick: () => void,
 * 	timeout?: number,
 *		isLoading?: boolean,
 * 	buttonProps: import('@chakra-ui/button').ButtonProps,
 * }} param0
 * @returns
 */
const ElectronLoginWithGoogle = ({
	timeout = 30,
	onClick,
	onTimeout,
	isLoading,
	buttonProps,
}) => {
	const loginClickTime = useRef('');
	const [loadingText, setLoadingText] = useState('');

	/**
	 * Opens login page on browser
	 */
	const handleLoginBtnClick = () => {
		loginClickTime.current = dayjs().toISOString();
		onClick();
		window.open(
			`${config.app.BASEURL}/login?autoLoginWithGoogle=true&desktopRedirect=true`,
			'_blank'
		);
	};

	useEffect(() => {
		const updateLoadingText = () => {
			/** time remaining in seconds before timeout */
			const remainingSeconds =
				timeout - dayjs().diff(loginClickTime.current, 'seconds');
			if (remainingSeconds && remainingSeconds > 0) {
				setLoadingText(`Waiting for login...(${remainingSeconds}s)`);
				setTimeout(updateLoadingText, 1000);
			} else {
				loginClickTime.current = '';
				onTimeout();
				clearTimeout(updateLoadingText);
			}
		};
		if (isLoading) updateLoadingText();
		return () => {
			clearTimeout(updateLoadingText);
		};
	}, [isLoading, onTimeout, timeout]);

	return (
		<Button
			size="md"
			marginTop="0.5rem"
			color="#525252"
			fontSize="0.8rem"
			bg="white"
			_hover={{
				bg: 'gray.200',
			}}
			_active={{
				bg: 'gray.100',
			}}
			leftIcon={<Icon as={FcGoogle} boxSize="6" />}
			loadingText={loadingText}
			{...buttonProps}
			isLoading={isLoading}
			onClick={handleLoginBtnClick}
		>
			Login with Google
		</Button>
	);
};

export default ElectronLoginWithGoogle;
